export {
  default,
  getContentHeadSEOData,
  type ContentHeadProps,
  type Metadata,
} from "./ContentHead";
